import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";
import PublicImage from "@/models/PublicImage/PublicImage";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class Information extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/information';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetInformations';

    static model_name = 'Information';

    static fields() {
		return {
			id: this.number(null).nullable(),
			display_type: this.attr(null),
			link_text: this.attr(null),
			link_url: this.attr(null),
			is_target_blank: this.boolean(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			information: this.attr(null),
			is_full_height: this.boolean(null),
			header_public_image_id: this.number(null).nullable(),
			website_route_id: this.number(null).nullable(),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            // routes: this.belongsToMany(WebsiteRoute),
            route: this.belongsTo(WebsiteRoute, 'website_route_id'),
            header_public_image: this.belongsTo(PublicImage, 'header_public_image_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Routes() {
        return this.getRelated('routes');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HeaderPublicImage() {
        return this.getRelated('header_public_image');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
